import { Text, UnorderedList, ListItem } from '@chakra-ui/react';
import { RequirementsSummary } from 'shared-components';

interface IProps {
  uploadComplete: boolean;
  highlightedSections: string[];
}

export default function Requirements(props: IProps) {
  const allSections = ['1.1', '1.2', '2.1', '2.2', '3.1', '3.2', '3.3', '3.4', '3.5', '4.1'];
  const sectionsToShow =
    props.highlightedSections && props.highlightedSections.length ? props.highlightedSections : allSections;

  return (
    <>
      {sectionsToShow.join('').indexOf('1.') !== -1 ? (
        <RequirementsSummary uploadWarning={props.uploadComplete} title={'1. Your letter must be signed and dated'}>
          {sectionsToShow.includes('1.1') || sectionsToShow.includes('1.2') ? (
            <UnorderedList>
              {sectionsToShow.includes('1.1') ? (
                <ListItem>Please ensure your parent or guardian has signed the letter</ListItem>
              ) : null}
              {sectionsToShow.includes('1.2') ? (
                <ListItem>The letter must include a date less than 31 days old</ListItem>
              ) : null}
            </UnorderedList>
          ) : null}
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('2.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'2. The body text of the letter must authorise you as the recipient of the nominated funds'}
        >
          <UnorderedList>
            {sectionsToShow.includes('2.1') ? (
              <ListItem>
                The letter must specify your name to identify you as the recipient of the funds (matching passport)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('2.2') ? (
              <ListItem>
                It must state the name of the parent providing the funds (matching birth/guardianship certificate)
              </ListItem>
            ) : null}
            {sectionsToShow.includes('2.3') ? (
              <ListItem>The amount in pounds being covered must be confirmed</ListItem>
            ) : null}
            {sectionsToShow.includes('2.4') ? (
              <ListItem>It must state the name of the course and the university</ListItem>
            ) : null}
            {sectionsToShow.includes('2.5') ? (
              <ListItem>
                The letter must confirm the funds are to be used for your course fees and/or living costs{' '}
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}

      {sectionsToShow.join('').indexOf('3.') !== -1 ? (
        <RequirementsSummary
          uploadWarning={props.uploadComplete}
          title={'3. The letter must be in English or have an English translation'}
        >
          <Text mb={2}>For letters not in English:</Text>

          <UnorderedList>
            {sectionsToShow.includes('3.1') ? (
              <ListItem>A translation must be included with the letter</ListItem>
            ) : null}
            {sectionsToShow.includes('3.2') ? (
              <ListItem>The translation must be signed and dated by a qualified translator</ListItem>
            ) : null}
            {sectionsToShow.includes('3.3') ? (
              <ListItem>
                Contact details and credentials for the translator must be included with the translation
              </ListItem>
            ) : null}
          </UnorderedList>
        </RequirementsSummary>
      ) : null}
    </>
  );
}
